<template>
  <b-form>
    <div class="row">
      <div class="col-md-6 mb-3">
        <label for="file_undangan_persiapan">
          Undangan Persiapan
          <span v-if="!fileIds.file_undangan_persiapan" class="text-danger">*</span>
        </label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex gap-2">
          <template v-if="hasRole(user, 'Penilai')">
            <b-form-file
              id="file_undangan_persiapan"
              v-model="form.file_undangan_persiapan"
              accept=".pdf,application/pdf"
              name="Undangan Persiapan"
              plain
              class="form-control"
              @change="validateFile($event, 'file_undangan_persiapan', 'PDF')"
            />
            <b-button
              variant="primary"
              :disabled="readOnly || !form.file_undangan_persiapan || uploadingFields.file_undangan_persiapan"
              @click="uploadFile('file_undangan_persiapan', 'Undangan Persiapan', 'PDF', 'pdf')"
            >
              <i class="fa fa-cloud-upload" /> Unggah
            </b-button>
          </template>
          <b-button
            variant="success"
            :disabled="!fileIds.file_undangan_persiapan"
            @click="downloadFile('file_undangan_persiapan')"
          >
            <i class="fa fa-download" /> Unduh
          </b-button>
        </div>
        <span v-if="fileErrors.file_undangan_persiapan" class="text-danger">{{
          fileErrors.file_undangan_persiapan
        }}</span>
        <small v-if="fileIds.file_undangan_persiapan" class="d-block text-muted">Dokumen sudah tersimpan.</small>
      </div>

      <div class="col-md-6 mb-3">
        <label for="file_undangan_kegiatan">
          Undangan Kegiatan
          <span v-if="!fileIds.file_undangan_kegiatan" class="text-danger">*</span>
        </label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex gap-2">
          <template v-if="hasRole(user, 'Penilai')">
            <b-form-file
              id="file_undangan_kegiatan"
              v-model="form.file_undangan_kegiatan"
              accept=".pdf,application/pdf"
              name="Undangan Kegiatan"
              plain
              class="form-control"
              @change="validateFile($event, 'file_undangan_kegiatan', 'PDF')"
            />
            <b-button
              variant="primary"
              :disabled="readOnly || !form.file_undangan_kegiatan || uploadingFields.file_undangan_kegiatan"
              @click="uploadFile('file_undangan_kegiatan', 'Undangan Kegiatan', 'PDF', 'pdf')"
            >
              <i class="fa fa-cloud-upload" /> Unggah
            </b-button>
          </template>
          <b-button
            variant="success"
            :disabled="!fileIds.file_undangan_kegiatan"
            @click="downloadFile('file_undangan_kegiatan')"
          >
            <i class="fa fa-download" /> Unduh
          </b-button>
        </div>
        <span v-if="fileErrors.file_undangan_kegiatan" class="text-danger">{{
          fileErrors.file_undangan_kegiatan
        }}</span>
        <small v-if="fileIds.file_undangan_kegiatan" class="d-block text-muted">Dokumen sudah tersimpan.</small>
      </div>

      <div class="col-md-6 mb-3">
        <label for="file_kak">
          KAK
          <span v-if="!fileIds.file_kak" class="text-danger">*</span>
        </label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex gap-2">
          <template v-if="hasRole(user, 'Penilai')">
            <b-form-file
              id="file_kak"
              v-model="form.file_kak"
              accept=".pdf,application/pdf"
              name="KAK"
              plain
              class="form-control"
              @change="validateFile($event, 'file_kak', 'PDF')"
            />
            <b-button
              variant="primary"
              :disabled="readOnly || !form.file_kak || uploadingFields.file_kak"
              @click="uploadFile('file_kak', 'KAK', 'PDF', 'pdf')"
            >
              <i class="fa fa-cloud-upload" /> Unggah
            </b-button>
          </template>
          <b-button variant="success" :disabled="!fileIds.file_kak" @click="downloadFile('file_kak')">
            <i class="fa fa-download" /> Unduh
          </b-button>
        </div>
        <span v-if="fileErrors.file_kak" class="text-danger">{{ fileErrors.file_kak }}</span>
        <small v-if="fileIds.file_kak" class="d-block text-muted">Dokumen sudah tersimpan.</small>
      </div>

      <div class="col-md-6 mb-3">
        <label for="file_desk_study">
          Desk Study
          <span v-if="!fileIds.file_desk_study" class="text-danger">*</span>
        </label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex gap-2">
          <template v-if="hasRole(user, 'Penilai')">
            <b-form-file
              id="file_desk_study"
              v-model="form.file_desk_study"
              accept=".pdf,application/pdf"
              name="Desk Study"
              plain
              class="form-control"
              @change="validateFile($event, 'file_desk_study', 'PDF')"
            />
            <b-button
              variant="primary"
              :disabled="readOnly || !form.file_desk_study || uploadingFields.file_desk_study"
              @click="uploadFile('file_desk_study', 'Desk Study', 'PDF', 'pdf')"
            >
              <i class="fa fa-cloud-upload" /> Unggah
            </b-button>
          </template>
          <b-button variant="success" :disabled="!fileIds.file_desk_study" @click="downloadFile('file_desk_study')">
            <i class="fa fa-download" /> Unduh
          </b-button>
        </div>
        <span v-if="fileErrors.file_desk_study" class="text-danger">{{ fileErrors.file_desk_study }}</span>
        <small v-if="fileIds.file_desk_study" class="d-block text-muted">Dokumen sudah tersimpan.</small>
      </div>

      <div class="col-md-6 mb-3">
        <label for="file_surat_tugas">
          Surat Tugas
          <span v-if="!fileIds.file_surat_tugas" class="text-danger">*</span>
        </label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex gap-2">
          <template v-if="hasRole(user, 'Penilai')">
            <b-form-file
              id="file_surat_tugas"
              v-model="form.file_surat_tugas"
              accept=".pdf,application/pdf"
              name="Surat Tugas"
              plain
              class="form-control"
              @change="validateFile($event, 'file_surat_tugas', 'PDF')"
            />
            <b-button
              variant="primary"
              :disabled="readOnly || !form.file_surat_tugas || uploadingFields.file_surat_tugas"
              @click="uploadFile('file_surat_tugas', 'Surat Tugas', 'PDF', 'pdf')"
            >
              <i class="fa fa-cloud-upload" /> Unggah
            </b-button>
          </template>
          <b-button variant="success" :disabled="!fileIds.file_surat_tugas" @click="downloadFile('file_surat_tugas')">
            <i class="fa fa-download" /> Unduh
          </b-button>
        </div>
        <span v-if="fileErrors.file_surat_tugas" class="text-danger">{{ fileErrors.file_surat_tugas }}</span>
        <small v-if="fileIds.file_surat_tugas" class="d-block text-muted">Dokumen sudah tersimpan.</small>
      </div>

      <div class="col-md-6 mb-3">
        <label for="file_data_drone">
          Data Drone
          <span v-if="!fileIds.file_data_drone" class="text-danger">*</span>
        </label>
        <small class="d-block">Format file: ZIP</small>
        <div class="d-flex gap-2">
          <template v-if="hasRole(user, 'Penilai')">
            <b-form-file
              id="file_data_drone"
              v-model="form.file_data_drone"
              accept=".zip"
              name="Data Drone"
              plain
              class="form-control"
              @change="validateFile($event, 'file_data_drone', 'ZIP')"
            />
            <b-button
              variant="primary"
              :disabled="readOnly || !form.file_data_drone || uploadingFields.file_data_drone"
              @click="uploadFile('file_data_drone', 'Data Drone', 'ZIP', 'zip')"
            >
              <i class="fa fa-cloud-upload" /> Unggah
            </b-button>
          </template>
          <b-button variant="success" :disabled="!fileIds.file_data_drone" @click="downloadFile('file_data_drone')">
            <i class="fa fa-download" /> Unduh
          </b-button>
        </div>
        <span v-if="fileErrors.file_data_drone" class="text-danger">{{ fileErrors.file_data_drone }}</span>
        <small v-if="fileIds.file_data_drone" class="d-block text-muted">Dokumen sudah tersimpan.</small>
      </div>
    </div>
  </b-form>
</template>

<script>
import api from '@/services/api'
import Swal from 'sweetalert2'
import { hasRole } from '@/helper/helpernew'

export default {
  props: {
    readOnly: { type: Boolean, default: false },
    rencanaAksiId: { type: [String, Number], default: null },
    documentIds: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {},
      form: {
        file_undangan_persiapan: null,
        file_undangan_kegiatan: null,
        file_kak: null,
        file_desk_study: null,
        file_surat_tugas: null,
        file_data_drone: null,
      },
      fileIds: {},
      fileErrors: {},
      uploadingFields: {},
    }
  },
  watch: {
    documentIds: {
      immediate: true,
      handler(ids) {
        this.fileIds = { ...ids }
      },
    },
  },
  methods: {
    hasRole,

    validateFile(event, key, format) {
      if (this.readOnly) return
      const file = event.target.files[0]
      const isInvalid = Boolean(file && !file.name.toLowerCase().endsWith(`.${format.toLowerCase()}`))
      this.$set(this.fileErrors, key, isInvalid ? `File harus berformat ${format}.` : null)
      if (isInvalid) this.$set(this.form, key, null)
    },
    async uploadFile(key, label, format, extension) {
      if (this.readOnly || this.uploadingFields[key]) return

      const file = this.form[key]
      if (!file) return

      const isInvalid = !file.name.toLowerCase().endsWith(`.${extension}`)
      this.$set(this.fileErrors, key, isInvalid ? `File harus berformat ${format}.` : null)
      if (isInvalid) return

      const formData = new FormData()
      formData.append(key, file)

      this.$set(this.uploadingFields, key, true)
      try {
        const response = await api.post(`api/rencana_aksi/${this.rencanaAksiId}`, formData)
        const fileId = response.data?.data?.[`id_${key}`]
        if (fileId) {
          this.$set(this.fileIds, key, fileId)
        } else {
          this.$emit('saved')
        }
        this.$set(this.form, key, null)
        await Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: `${label} berhasil diunggah.`,
          timer: 1500,
          showConfirmButton: false,
        })
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: error.response?.data?.message || `Gagal mengunggah ${label}.`,
        })
      } finally {
        this.$set(this.uploadingFields, key, false)
      }
    },
    async downloadFile(key) {
      const id = this.fileIds[key]
      if (!id) return
      await this.downloadExistingFile(id)
    },
    async downloadExistingFile(id) {
      try {
        const response = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
        const fileURL = URL.createObjectURL(new Blob([response.data], { type: response.data.type }))
        window.open(fileURL, '_blank')
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: error.response?.data?.message || 'Gagal mengunduh dokumen.',
        })
      }
    },
    async saveDokumenPersiapan() {
      const isUndanganPersiapanFilled = Boolean(this.fileIds.file_undangan_persiapan)
      const isUndanganKegiatanFilled = Boolean(this.fileIds.file_undangan_kegiatan)
      const isKakFilled = Boolean(this.fileIds.file_kak)
      const isDeskStudyFilled = Boolean(this.fileIds.file_desk_study)
      const isSuratTugasFilled = Boolean(this.fileIds.file_surat_tugas)
      const isDataDroneFilled = Boolean(this.fileIds.file_data_drone)

      this.$set(
        this.fileErrors,
        'file_undangan_persiapan',
        isUndanganPersiapanFilled ? null : 'Dokumen wajib diunggah.',
      )
      this.$set(this.fileErrors, 'file_undangan_kegiatan', isUndanganKegiatanFilled ? null : 'Dokumen wajib diunggah.')
      this.$set(this.fileErrors, 'file_kak', isKakFilled ? null : 'Dokumen wajib diunggah.')
      this.$set(this.fileErrors, 'file_desk_study', isDeskStudyFilled ? null : 'Dokumen wajib diunggah.')
      this.$set(this.fileErrors, 'file_surat_tugas', isSuratTugasFilled ? null : 'Dokumen wajib diunggah.')
      this.$set(this.fileErrors, 'file_data_drone', isDataDroneFilled ? null : 'Dokumen wajib diunggah.')

      const isComplete =
        isUndanganPersiapanFilled &&
        isUndanganKegiatanFilled &&
        isKakFilled &&
        isDeskStudyFilled &&
        isSuratTugasFilled
        isDataDroneFilled

      if (!isComplete) {
        await Swal.fire({
          icon: 'warning',
          title: 'Dokumen belum lengkap',
          text: 'Unggah semua dokumen persiapan terlebih dahulu.',
        })
        return false
      }

      await Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: 'Semua dokumen persiapan sudah lengkap.',
      })
      return true
    },
  },
}
</script>
